import type {PerkADto} from '@cohort/admin-schemas/perk';
import {PerkAppBadge} from '@cohort/merchants/components/perks/PerkAppBadge';
import {PerkTypeBadge} from '@cohort/merchants/components/perks/PerkTypeBadge';
import {cn} from '@cohort/shared-frontend/utils/classNames';

type DigitalAssetCollectionPerksListProps = {
  perks: Array<PerkADto>;
  size?: 'default' | 'small';
};

const DigitalAssetCollectionPerksList: React.FC<DigitalAssetCollectionPerksListProps> = ({
  perks,
  size = 'default',
}) => (
  <div className="grid gap-4 [grid-template-columns:max-content_1fr]">
    <ul className="flex flex-col gap-2">
      {perks.map(perk => (
        <li key={perk.id}>
          <span className={cn('font-medium', size === 'default' ? 'text-sm' : 'text-xs')}>
            {perk.internalName}
          </span>
        </li>
      ))}
    </ul>
    <ul className="mt-0.5 flex flex-col gap-2">
      {perks.map(perk => (
        <li key={perk.id}>
          <PerkTypeBadge perkType={perk.type} />
          &nbsp;
          <PerkAppBadge perkIntegrationId={perk.integration?.perkIntegrationId ?? null} />
        </li>
      ))}
    </ul>
  </div>
);

export default DigitalAssetCollectionPerksList;
